import { render, staticRenderFns } from "./SingleAction.vue?vue&type=template&id=850ecd3e"
import script from "./SingleAction.vue?vue&type=script&lang=js"
export * from "./SingleAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports